module.exports = __webpack_public_path__ + "img/nasacort_allergy_24_hr_spray.b85ccadd.png";